module.exports = __webpack_public_path__ + "assets/close-green.ace6f969.svg";